export default {
  namespaced: true,
  actions: {
  },
  mutations: {
    goodsPrice(state, value) {
      state.goodsPrice = value
    },
    shelves(state, value) {
      state.goodsPrice = value.goodsPrice
    },
  },
  state: {
    goodsPrice: 0, //商品上架价格
  },
  getters: {
  },
}